/**
 * Syncing Custom Meal subscriptions with their linked option products
 * using Shopify apps:
 * - SC Product Options
 * - Subi Subscriptions
 *
 * Ensures that all hidden child products inherit the selling plan
 * from their parent Custom Meal automatically.
 */

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('product-form').forEach(formEl => {
    formEl.addEventListener('add-to-cart', () => {
      syncCustomMealSubscription();
    });
  });
});

let syncing = false;

async function syncCustomMealSubscription() {
  if (syncing) return;
  syncing = true;

  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    // Find all Custom Meal items with subscription
    const customMealItems = cart.items.filter(
      item => item.title === 'Custom Meal' && item.selling_plan_allocation
    );

    if (!customMealItems.length) return;

    for (const parent of customMealItems) {
      const sellingPlanId = parent.selling_plan_allocation.selling_plan.id;
      const parentBuilderId = parent.properties._boldBuilderId;

      // Find linked option products
      const optionProducts = cart.items.filter(
        item =>
          item.product_type === 'OPTIONS_HIDDEN_PRODUCT' &&
          item.properties._boldBuilderId === parentBuilderId &&
          !item.selling_plan_allocation
      );

      for (const child of optionProducts) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: child.key,
            selling_plan: sellingPlanId,
            quantity: child.quantity
          })
        });
      }
    }
  } catch (err) {
    console.error('Custom Meal subscription sync error:', err);
  } finally {
    syncing = false;
  }
}